import React from 'react';
import BoardComponent from './Board.component';
import { adaptBoardEditorProps } from './Board.adapter';

/**
 * 게시판 컴포넌트 에디터
 * 모든 속성 설정은 속성 탭에서만 수행되며, 에디터 화면에서는 결과만 보여줍니다.
 */
const BoardEditor: React.FC<any> = (props) => {
  // 어댑터를 통해 props 변환
  const adaptedProps = adaptBoardEditorProps(props);
  
  // 에디터 전용 props 분리
  const { isSelected, isPreview, updateComponent, ...componentProps } = adaptedProps;
  
  // 원본 updateComponent 함수 래핑
  const wrappedUpdateComponent = (changes: any) => {
    // 원본 updateComponent 호출
    props.updateComponent(changes);
  };
  
  // 변환된 componentProps를 사용하되, updateComponent는 래핑된 함수로 교체
  // 웹빌더 에디터 환경에서는 항상 isPreview=true로 설정
  return <BoardComponent 
    {...componentProps} 
    updateComponent={wrappedUpdateComponent}
    isPreview={true}
  />;
};

export default BoardEditor; 